module.exports = __webpack_public_path__ + "img/03.927b030e.png";